module.exports = __webpack_public_path__ + "img/7-Pivot-Complete.3577bb28.png";